export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/appointment-list/:pageId',
        component: () => import('@/views/page/company/dental-os/appointment/AppointmentList.vue'),
        name: 'appointment-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/dental-service/:pageId/general/:serviceId',
        component: () => import('@/views/page/company/dental-os/service/DentalService.vue'),
        name: 'dental-service',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/dental-schedule/:pageId',
        component: () => import('@/views/page/company/dental-os/dental-schedule/Calendar.vue'),
        name: 'dental-schedule',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-dental-schedule/:pageId',
        component: () => import('@/views/page/company/dental-os/dental-schedule/MyCalendar.vue'),
        name: 'my-dental-schedule',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/dental-schedule-list/:pageId',
        component: () => import('@/views/page/company/dental-os/dental-schedule/List.vue'),
        name: 'dental-schedule-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-dental-schedule-list/:pageId',
        component: () => import('@/views/page/company/dental-os/dental-schedule/MyList.vue'),
        name: 'my-dental-schedule-list',
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/dental-money-receipt/:pageId',
        component: () => import('@/views/page/company/dental-os/money-receipt/MoneyReceipt.vue'),
        name: 'dental-money-receipt',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/dental-statement/:pageId/edit',
        component: () => import('@/views/page/company/dental-os/ipd-bill/IpdStatementUpdate.vue'),
        name: 'dental-statement-edit',
        meta: {
            requiresAuth: true
        }
    },
];